import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import { update } from '#components/generics/js/selectors/toggleAll.js'
import * as utilities from '#utilities/js/styles.js'
import { handle } from './list.js'

const lines = new WeakMap()

const types = object(null, {
  uid: (line, key, value) => parse(line, key)?.includes(value)
})

const parse = (line, key) => {
  if (!lines.has(line)) {
    const { dataset } = line
    const { filters } = dataset

    lines.set(line, JSON.parse(filters))
  }

  return lines.get(line)[key]
}

const filter = (filters, line) => {
  for (const { dataset, value } of filters) {
    if (value === 'all') {
      continue
    }

    const { filterKey, filterType } = dataset

    if (!types[filterType](line, filterKey, value)) {
      return false
    }
  }

  return true
}

const handler = (table, selects) => {
  const lines = all('[data-filters]', table)
  const toggler = one(`[data-toggle-all]`, table)

  for (const line of lines) {
    if (filter(selects, line)) {
      line.classList.remove(utilities.modifiers.display.none)
    } else {
      line.classList.add(utilities.modifiers.display.none)
    }
  }

  if (toggler) {
    const [{ form }] = selects
    const { dataset } = toggler
    const { toggleAll } = dataset

    update(form, toggleAll)
  }
}

export default select => {
  handle(select, handler)
}
